import Vue from 'vue'

const finance = {
    loadRate (updateRate) {
        Vue.axios.get('finance/refresh/rate')
            .then(response => {
                let rate = response.data['rate']
                updateRate(rate)
            })
    }
}

export default finance



// WEBPACK FOOTER //
// ./src/api/finance.js